import { AfterViewChecked, AfterViewInit, Component, ElementRef, EventEmitter, Input, linkedSignal, Output, signal, Signal, ViewChild, WritableSignal } from '@angular/core';

@Component({
  selector: 'app-media-selector',
  imports: [],
  templateUrl: './media-selector.component.html',
  styleUrl: './media-selector.component.scss'
})
export class MediaSelectorComponent implements AfterViewInit, AfterViewChecked {

  @ViewChild('scroll') scroll!: ElementRef;

  @Input('media') media!: Signal<string[]>;
  @Input('selectedMedia') selectedMedia!: WritableSignal<string>;

  @Output('handleChangeMedia') handleChangeMedia: EventEmitter<number> = new EventEmitter();

  public readonly SAFFRON_STAR = "./../../../../assets/icons/star-saffron.svg";

  public canScroll: WritableSignal<boolean> = signal(false);

  public get cantScrollUp(): boolean {
    let cantScrollUp = true;
    if (this.scroll.nativeElement) {
      let { scrollTop } = (this.scroll.nativeElement as HTMLElement);
      cantScrollUp = scrollTop === 0;
    }
    return cantScrollUp;
  }

  public get cantScrollDown(): boolean {
    let cantScrollDown = true;
    if (this.scroll.nativeElement) {
      let { scrollTop, clientHeight, scrollHeight } = (this.scroll.nativeElement as HTMLElement);
      cantScrollDown = Math.abs(scrollHeight - scrollTop - clientHeight) < 1;
    }
    return cantScrollDown;
  }

  //Uso un linkedSignal collegato a media() per gestire eventuali errori nel reperimento dell'immagine
  public images: WritableSignal<string[]> = linkedSignal(() => this.media());

  ngAfterViewInit(): void {
    this.checkScroll();
  }

  ngAfterViewChecked(): void {
    this.checkScroll();
  }

  checkScroll() {
    if (this.scroll.nativeElement) {
      let { scrollTop, offsetHeight, scrollHeight, clientHeight } = (this.scroll.nativeElement as HTMLElement);
      // let isScrollable = Math.abs(scrollTop + offsetHeight - scrollHeight) >= 2;
      let isScrollable = Math.abs(scrollHeight - clientHeight) > 1;
      this.canScroll.set(isScrollable);
    }
  }

  handleOnError(index: number) {
    let images = [...this.images()];
    images.splice(index, 1);
    this.images.set(images);
  }

  handleSelectImage(index: number) {
    let image = this.images()[index];
    this.selectedMedia.set(image);
    this.handleChangeMedia.emit(index);
  }

  handleScrollUp() {
    this.handleScroll(-1);
  }

  handleScrollDown() {
    this.handleScroll(1);
  }

  handleScroll(k: 1 | -1) {
    this.scroll.nativeElement.scrollTop = this.scroll.nativeElement.scrollTop + (k * 90 * 3);
  }

}
